angular.module('admin')
  .controller('AgentSponsorsCtrl', ['$scope', '$state', 'AgentService', 'PageNotificationService', function($scope, $state, AgentService, PageNotificationService){

    $scope.agentId =  $state.params.id;

    function getAgent(){
      return AgentService.getOne($scope.agentId)
        .then((agent) => {
          $scope.agent = agent;
        });
    };

    function getSponsor(){
      if(!$scope.agent.sponsor_id) return;

      return AgentService.getSponsor($scope.agentId)
        .then((sponsor) => {
          if(!_.isEmpty(sponsor))
            $scope.sponsor = sponsor;
        });
    };

    $scope.refresh = function(){
      $scope.loading = true;

      return getAgent()
        .then(getSponsor)
        .then(() => {
          $scope.loading = false;
        })
        .catch((err) => {
          $scope.loading = false;
          $scope.error = 'There was an error loading your sponsors: ' + err;
        });
    };

    $scope.refresh();
  }]);
